import Client from '@/app/repository/axios-client';

const resource = '/report/reports';

export default {
  getBalanceOperationsForGrid(payload) {
    return Client.get(`${resource}/balance-operations/grid` + payload);
  },
  getBalanceOperationsForExcel(payload) {
    return Client.get(`${resource}/balance-operations/excel` + payload,
      {
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      });
  },
};
